var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoCodigoBarras01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Shape_10_",
    className: "st0",
    d: "M31.9,28.5H4.1V7.5h27.9V28.5z M26.7,11V25h1.7V11H26.7z M19.7,11V25H25V11H19.7z M16.3,11V25 H18V11H16.3z M12.8,11V25h1.7V11H12.8z M7.5,11V25H11V11H7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2_2_",
    d: "M31.9,31.9H4.1c-1.9,0-3.5-1.6-3.5-3.5V7.5c0-1.9,1.6-3.5,3.5-3.5h27.9c1.9,0,3.5,1.6,3.5,3.5v20.9 C35.4,30.4,33.9,31.9,31.9,31.9z M4.1,7.5v20.9h27.9V7.5H4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    d: "M28.5,25h-1.7V11h1.7V25z M25,25h-5.2V11H25V25z M18,25h-1.7V11H18V25z M14.5,25h-1.7V11h1.7V25z M11,25H7.5 V11H11V25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCodigoBarras01);
export default __webpack_public_path__ + "static/media/ico-codigo-barras-01.b727c7c0d9797be39abcf491250e008f.svg";
export { ForwardRef as ReactComponent };